var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{ref:"Main",staticClass:"mb-0 fixed-top in-maintenance",attrs:{"show":!this.$store.getters['auth/isLoggedAs'] && this.$store.getters['auth/inMaintenance'],"variant":"warning"}},[_vm._v("\n  This scope "),_c('strong',[_vm._v(_vm._s(this.$store.getters["auth/scopeDefault"].name))]),_vm._v(" is in Maintenance\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }